import React, { useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { makeStyles } from '@mui/styles';
import { useTranslation } from "react-i18next";
import {
  Modal,
  Grid,
  Typography,
  Chip
} from '@mui/material';
import Button from "components/CustomButtons/Button.js";
import CancelIcon from '@mui/icons-material/Cancel';
import AlertDialog from '../components/AlertDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import BlockIcon from '@mui/icons-material/Block';
import {colors} from '../components/Theme/WebTheme';
import moment from 'moment/min/moment-with-locales';
import {
  modernTableStyle,
  modernTableOptions,
  modernTableIcons,
  modernTableLocalization,
  PageHeader,
  MercosulPlateBadge,
  TableEditInput,
  TablePlateEditInput,
  TableSelectEditInput
} from '../common/tableTheme';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2)
  },
  submit3:{
    width:'100%',
    borderRadius: '10px',
    marginTop: 12,
    padding: '10px 16px',
    backgroundColor: '#2563eb',
    color: '#ffffff',
    fontWeight: 600,
    textTransform: 'none'
  },
  paper: {
    width: 480,
    maxWidth: '92vw',
    backgroundColor: '#ffffff',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(3),
    borderRadius: '16px',
    border: '1px solid #e2e8f0',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none'
  },
}));

export default function CarsList() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const [drivers,setDrivers] = useState([]);
  const {
    updateUserCar,
    editCar
  } = api;
  const [driversObj, setDriversObj] = useState();
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [data, setData] = useState([]);
  const cartypes = useSelector(state => state.cartypes);
  const carlistdata = useSelector(state => state.carlistdata);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [cars, setCars] = useState({});
  const [role, setRole] = useState(null);
  
  useEffect(() => {
    if(role !== 'driver' && userdata.users){
        let arr =  userdata.users.filter(user => user.usertype==='driver' && ((role === 'fleetadmin' && user.fleetadmin && user.fleetadmin === auth.profile.uid) || role === 'admin'));
        let obj = {}; 
        let obj2 =  {};
        let arr2 = [];
        for(let i=0;i  < arr.length; i++){
            let user = arr[i];
            arr2.push({id: user.id, desc:user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden")});
            obj[user.id]=user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden");
            obj2[user.id]=user.fleetadmin?user.fleetadmin:null
        }
        setDrivers(arr2);
        setDriversObj(obj);
        setFleetMapObj(obj2);    
    } 
  }, [userdata.users,settings.AllowCriticalEditsAdmin,role,auth.profile.uid]);

  useEffect(()=>{
    if(cartypes.cars){
        let obj =  {};
        cartypes.cars.sort((a, b) => a.pos - b.pos).map((car)=> obj[car.name]=car.name)
        setCars(obj);
    }
  },[cartypes.cars]);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata.cars) {
      const profile = auth.profile;
      const tId = profile?.tenant_id || profile?.tenantId;
      const isSuper = profile?.is_superadmin || profile?.usertype === 'superadmin';
      const filtered = carlistdata.cars.filter(car => {
        if (isSuper) return true;
        if (tId) return car.tenant_id === tId || car.tenantId === tId;
        if (role === 'fleetadmin') return car.fleetadmin === profile?.uid;
        return true;
      });
      setData(filtered);
    } else {
      setData([]);
    }
  }, [carlistdata.cars, auth.profile, role]);

  const [selectedImage, setSelectedImage] = useState(null); 
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  }

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] =  useState(false);
  const [imageData, setImageData] =  useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleSetProfileModal = (e) =>{
    e.preventDefault();
    if(selectedImage){
      setLoading(true);
      let finalData = userData;
      finalData.car_image = selectedImage;
      dispatch(editCar(finalData, "UpdateImage"));
      setProfileModal(false); 
      setTimeout(()=>{
        setSelectedImage(null);
        setLoading(false); 
      },10000);
    }
    else{
      setCommonAlert({ open: true, msg: t('choose_image_first') })
    }
  }

  const onClick = (rowData) => {
    setImageData(rowData.car_image);
    setProfileModal(true);
    setUserData(rowData);
  };
  
  const columns = [
    { 
      title: t('vehicle_reg_no') || 'Placa', 
      field: 'vehicleNumber',
      render: rowData => <MercosulPlateBadge plate={rowData.vehicleNumber} />,
      cellStyle: { textAlign: 'center', width: 140 },
      headerStyle: { textAlign: 'center', width: 140 },
      editComponent: props => (
        <TablePlateEditInput
          value={props.value}
          onChange={props.onChange}
        />
      )
    },
    { 
      title: 'Marca', 
      field: 'vehicleMake',
      render: rowData => (
        <span style={{ fontWeight: 600, color: '#0f172a' }}>{rowData.vehicleMake}</span>
      ),
      editComponent: props => (
        <TableEditInput
          placeholder="Ex: Toyota, VW, Fiat"
          value={props.value}
          onChange={props.onChange}
          autoFocus
        />
      )
    },
    { 
      title: 'Modelo', 
      field: 'vehicleModel',
      render: rowData => (
        <span style={{ fontWeight: 500, color: '#334155' }}>{rowData.vehicleModel}</span>
      ),
      editComponent: props => (
        <TableEditInput
          placeholder="Ex: Corolla, Gol, Argo"
          value={props.value}
          onChange={props.onChange}
        />
      )
    },
    { 
      title: 'Ano / Detalhes', 
      field: 'other_info',
      render: rowData => (
        <Typography variant="body2" sx={{ fontSize: '0.75rem', color: '#64748b' }}>
          {rowData.other_info || '-'}
        </Typography>
      ),
      editComponent: props => (
        <TableEditInput
          placeholder="Ex: 2024 • Prata • Flex"
          value={props.value}
          onChange={props.onChange}
        />
      )
    },
    { 
      title: t('car_type') || 'Categoria', 
      field: 'carType', 
      lookup: cars,
      editComponent: props => (
        <TableSelectEditInput
          value={props.value}
          onChange={props.onChange}
          placeholder="Selecione categoria..."
          options={Object.entries(cars).map(([key, name]) => ({ value: key, label: name }))}
        />
      )
    },
    { 
      title: t('driver') || 'Condutor Vinculado', 
      field: 'driver', 
      editable: role === 'driver'? 'never': 'always',
      render: rowData => {
        if (rowData && rowData.driver && driversObj && driversObj[rowData.driver]) {
          return (
            <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.8125rem' }}>
              {driversObj[rowData.driver]}
            </div>
          );
        }
        return <span style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '0.8125rem' }}>Sem condutor vinculado</span>;
      },
      editComponent: props => (
        <Autocomplete
          id="select-car-driver"
          size="small"
          options={drivers}
          value={drivers.find(d => d.id === props.value) || null}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option?.desc || '')}
          isOptionEqualToValue={(option, val) => option?.id === val?.id || option?.id === val}
          style={{ minWidth: 260 }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Pesquisar condutor..."
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#ffffff',
                  borderRadius: '8px',
                  fontSize: '0.8125rem',
                  '& fieldset': { borderColor: '#cbd5e1', borderWidth: '1.5px' },
                  '&:hover fieldset': { borderColor: '#94a3b8' },
                  '&.Mui-focused fieldset': { borderColor: '#2563eb', borderWidth: '2px' }
                },
                '& .MuiOutlinedInput-input': { padding: '3px 8px !important' }
              }}
            />
          )}
          onChange={(event, newValue) => {
            props.onChange(newValue ? newValue.id : null);
          }}
        />
      ),
      exportTransformer: (rowData) => driversObj && driversObj[rowData.driver],
      hidden: role === 'driver'? true: false,
    },
    { 
      title: t('image') || 'Foto', 
      field: 'car_image',
      initialEditValue: 'https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png',
      editable: 'never',
      cellStyle: { textAlign: 'center', width: 70 },
      headerStyle: { textAlign: 'center', width: 70 },
      render: rowData => rowData.car_image ? (
        <Tooltip title="Alterar foto">
          <button 
            onClick={() => onClick(rowData)}
            style={{ 
              border: '1px solid #e2e8f0', 
              borderRadius: '8px', 
              padding: 2, 
              background: '#f8fafc', 
              cursor: 'pointer',
              overflow: 'hidden',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img alt='Car' src={rowData.car_image} style={{ width: 44, height: 28, objectFit: 'contain', display: 'block' }}/>
          </button>
        </Tooltip>
      ) : null
    },
    { 
      title: t('active_status') || 'Operacional', 
      field: 'active', 
      editable: role === 'admin' ? 'never': 'always', 
      type: 'boolean',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      render: rowData => (
        <Chip
          size="small"
          label={rowData.active ? 'Operacional' : 'Inativo'}
          sx={{
            bgcolor: rowData.active ? '#dcfce7' : '#f1f5f9',
            color: rowData.active ? '#15803d' : '#64748b',
            fontWeight: 700,
            fontSize: '0.75rem',
            borderRadius: '6px'
          }}
        />
      ),
      editComponent: props => (
        <TableSelectEditInput
          value={props.value === undefined ? true : Boolean(props.value)}
          onChange={val => props.onChange(val === 'true' || val === true)}
          options={[
            { value: true, label: '🟢 Operacional' },
            { value: false, label: '⚪ Inativo' }
          ]}
        />
      )
    },
    { 
      title: t('approved') || 'Homologação', 
      field: 'approved', 
      editable: 'never', 
      type: 'boolean',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      render: rowData => (
        <Chip
          size="small"
          label={rowData.approved ? 'Homologado' : 'Pendente'}
          sx={{
            bgcolor: rowData.approved ? '#eff6ff' : '#fef3c7',
            color: rowData.approved ? '#1d4ed8' : '#b45309',
            fontWeight: 700,
            fontSize: '0.75rem',
            borderRadius: '6px'
          }}
        />
      )
    },
    { 
      title: t('createdAt') || 'Cadastro', 
      field: 'createdAt', 
      editable: 'never', 
      defaultSort: 'desc',
      render: rowData => rowData.createdAt ? moment(rowData.createdAt).format('DD/MM/YYYY') : null,
      cellStyle: { textAlign: isRTL === 'rtl' ? 'right' : 'center', fontSize: '0.8125rem', color: '#64748b' },
      headerStyle: { textAlign: isRTL === 'rtl' ? 'right' : 'center' }
    }
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    carlistdata.loading ? <CircularLoading /> :
    <div ref={rootRef} style={{ padding: '4px' }}>
      <PageHeader 
        title={t('cars') || 'Frota de Veículos'} 
        subtitle="Gerenciamento da frota, vinculação de condutores e controle operacional dos veículos."
        count={data.length}
      />
      <MaterialTable
        title=""
        columns={columns}
        style={modernTableStyle}
        icons={modernTableIcons}
        localization={modernTableLocalization}
        data={data}
        onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        options={modernTableOptions(selectedRow, {
          searchPlaceholder: "Buscar veículo, modelo, placa ou condutor...",
          maxBodyHeight: "calc(100vh - 250px)"
        })}
        editable={{
          onRowAdd: newData =>
          settings.AllowCriticalEditsAdmin?
            new Promise((resolve, reject) => {
              setTimeout(() => {
                const cleanPlate = (newData?.vehicleNumber || '').toUpperCase().trim();
                const make = (newData?.vehicleMake || '').trim();
                const model = (newData?.vehicleModel || '').trim();
                const carType = newData?.carType || (cartypes.cars && cartypes.cars[0]?.name) || '';

                if (!cleanPlate || !make || !model || !carType) {
                  alert('Por favor, preencha os campos obrigatórios: Placa, Marca, Modelo e Categoria.');
                  reject();
                  return;
                }

                const defaultCarImg = 'https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png';
                const profile = auth.profile;
                const tenantId = profile?.tenant_id || profile?.tenantId || null;
                let selectDriver = role === 'admin'? newData.driver : profile.uid;
                let activeCar = null;

                let updateData = { 
                  carType: carType,
                  vehicleNumber: cleanPlate,
                  vehicleMake: make,
                  vehicleModel: model,
                  other_info: newData.other_info || '',
                  car_image: newData.car_image || defaultCarImg,
                  updateAt: new Date().getTime()
                };

                for(let i=0; i < data.length; i++){
                  if(data[i].driver === newData.driver && data[i].active){
                    activeCar = data[i];
                    break;
                  }
                }

                if(activeCar && newData.active){
                  activeCar.active = false;
                  dispatch(editCar(activeCar,"Update"));
                  if(selectDriver) dispatch(updateUserCar(selectDriver, updateData));
                } else if(activeCar && !newData.active){
                  newData.active = false;           
                } else {
                  newData.active = (newData.active === undefined) ? true : Boolean(newData.active);
                  if(selectDriver) dispatch(updateUserCar(selectDriver, updateData));
                }

                if(role === 'driver'){
                  newData['driver'] = selectDriver;
                }
                newData['vehicleNumber'] = cleanPlate;
                newData['vehicleMake'] = make;
                newData['vehicleModel'] = model;
                newData['other_info'] = newData.other_info || '';
                newData['car_image'] = newData.car_image || defaultCarImg;
                newData['carType'] = carType;
                if (tenantId) {
                  newData['tenant_id'] = tenantId;
                  newData['tenantId'] = tenantId;
                }
                newData['createdAt'] = new Date().getTime();
                newData['fleetadmin'] = newData['driver']? (fleetMapObj[newData['driver']]?fleetMapObj[newData['driver']]: null): null;
                if(!settings.carApproval){
                  newData['approved'] = true;
                  if(newData.active && newData.driver){
                    dispatch(updateUserCar(newData.driver,{carApproved: true}));
                  }
                } else {
                  newData['approved'] = false;
                }
                dispatch(editCar(newData,"Add"));
                resolve();
              }, 300);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 300);
            }),
          onRowUpdate: (newData, oldData) =>
            settings.AllowCriticalEditsAdmin?
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                if(newData !== oldData){
                  const cleanPlate = (newData.vehicleNumber || '').toUpperCase().trim();
                  newData.vehicleNumber = cleanPlate;
                  newData.vehicleMake = (newData.vehicleMake || '').trim();
                  newData.vehicleModel = (newData.vehicleModel || '').trim();
                  newData.other_info = newData.other_info || '';

                  let activeCar = null;
                  let updateData = { 
                    carType: newData.carType,
                    vehicleNumber: newData.vehicleNumber,
                    vehicleMake: newData.vehicleMake,
                    vehicleModel: newData.vehicleModel,
                    other_info: newData.other_info,
                    car_image: newData.car_image,
                    updateAt: new Date().getTime()
                  };
                  for(let i=0;i<data.length;i++){
                    if(data[i].driver === newData.driver && data[i].active && data[i].id !== oldData.id){
                      activeCar = data[i];
                      break;
                    }
                  }
                  if(activeCar && newData.active){
                    activeCar.active = false;
                    dispatch(editCar(activeCar,"Update"));
                    if(newData.driver) dispatch(updateUserCar(newData.driver,updateData));
                  } else if(activeCar && !newData.active){
                    newData.active = false;           
                  } else {
                    newData.active = (newData.active === undefined) ? true : Boolean(newData.active);
                    if(newData.driver) dispatch(updateUserCar(newData.driver,updateData));
                  }
                  newData['fleetadmin'] = newData['fleetadmin']? fleetMapObj[newData['driver']]:null;
                  delete newData.tableData;
                  dispatch(editCar(newData,"Update"));
                  if(newData.driver !== oldData.driver && oldData.driver){
                    dispatch(updateUserCar(oldData.driver,
                      { 
                        carType: null,
                        vehicleNumber: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        other_info: null,
                        car_image: null,
                        updateAt: new Date().getTime()
                      }));
                  }
                }
              }, 300);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 300);
            }),
          onRowDelete: oldData =>
            settings.AllowCriticalEditsAdmin?
            new Promise((resolve, reject) => {
              setTimeout(() => {
                if(oldData.active){
                    reject();
                    alert(t('active_car_delete'));
                } else {
                    resolve();
                    dispatch(editCar(oldData,"Delete"));
                }
              }, 300);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 300);
            })
        }}
        actions={[
          rowData => (settings.carApproval && role === 'admin' ?{
            icon: () => 
              rowData.approved? 
                <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
                  <BlockIcon />
                  <Typography variant="subtitle2">{t('reject')}</Typography>
                </div>
                :
                <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
                  <DoneAllIcon />
                  <Typography variant="subtitle2">{t('accept')}</Typography>
                </div>
            ,
            onClick: (event, rowData) => {
              if(rowData.active){
                  dispatch(updateUserCar(rowData.driver,{carApproved: !rowData.approved}));
              }
              dispatch(editCar({...rowData, approved: !rowData.approved},"Update"));  
            }
          }:null),
        ]}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
      <Grid container spacing={1} className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
                {t('car_image')}
              <input
                  type="file"
                  style={{marginLeft:10}}
                  name= {t('image')}
                  onChange={(event) => {
                      setSelectedImage(event.target.files[0]);
                  }}
              />
            </Typography>
         </Grid>
         <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage  && !loading ? 
                    <Tooltip title={t('cancel')}>
                      <CancelIcon onClick={()=>setSelectedImage(null)} style={{ fontSize: 30,backgroundColor:'red',borderRadius:50,color:"white" }}  />
                    </Tooltip>
                  : null }
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage ? 
                   <img alt="not fount" width={"200px"} height={"200px"}  src={URL.createObjectURL(selectedImage)} style={{marginTop:15,marginBottom:20}}/>
                   :
                    <img alt="not fount" width={"200px"} height={"200px"}  src={imageData} style={{marginTop:10}}/>
                  }
                <br />
                </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {loading ? 
            <Grid
              container
              spacing={0}
              alignItems="center"
              justify="center"
              style={{ minHeight: '5vh' }} >
              <CircularProgress/>
            </Grid>
            :
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            <Button onClick={handleProfileModal} variant="contained" color="danger">
              {t('cancel')}
            </Button>
            <Button onClick={handleSetProfileModal} variant="contained" color="secondaryButton" style={{marginLeft:10}}>
              {t('save')}
            </Button>
            </Grid>
          }
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}
